export const MAX_HISTORY_ENTRIES = 10;
